var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1102",
    "data-name": "Group 1102",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.902,
    height: 25.848,
    viewBox: "0 0 19.902 25.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2859",
    "data-name": "Path 2859",
    d: "M18.851,2A9.983,9.983,0,0,0,8.9,11.951c0,7.84,9.262,15.466,9.693,15.81a.431.431,0,0,0,.517,0c.388-.3,9.693-7.97,9.693-15.81A9.983,9.983,0,0,0,18.851,2Zm0,24.857c-1.551-1.335-9.09-8.185-9.09-14.905a9.09,9.09,0,0,1,18.18,0C27.941,18.672,20.4,25.521,18.851,26.857Z",
    transform: "translate(-8.9 -2)",
    fill: "#9e9e9e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2860",
    "data-name": "Path 2860",
    d: "M26.166,13a5.566,5.566,0,1,0,5.566,5.566A5.563,5.563,0,0,0,26.166,13Zm0,10.155a4.589,4.589,0,1,1,4.589-4.589A4.584,4.584,0,0,1,26.166,23.155Z",
    transform: "translate(-16.214 -8.648)",
    fill: "#9e9e9e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e028a56dae8d35f242be095c3f5df3ca.svg";
export { ForwardRef as ReactComponent };